import { render, staticRenderFns } from "./PurchasesVsSales.vue?vue&type=template&id=c2f4f6e8&scoped=true&"
import script from "./PurchasesVsSales.vue?vue&type=script&lang=ts&"
export * from "./PurchasesVsSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f4f6e8",
  null
  
)

export default component.exports